const setOtherFilters = (state, filter) => {
  if (state.otherFilters === null) {
    state.otherFilters = {}
  }
  state.otherFilters = filter
}

const setFilter = (state, filter) => {
  state.selectedFilters[filter.filterType] = filter.filterValue
}

const clearFilters = state => {
  Object.assign(state, {
    selectedFilters: {
      channel: [],
      healthCommunitySpecialistSpeciality: [],
      type: [],
      specialty: [],
      physician: [],
      case: null
    }
  })
}

const clearOtherFilters = state => {
  Object.assign(state, {
    otherFilters: null
  })
}

export default {
  clearFilters,
  setOtherFilters,
  clearOtherFilters,
  setFilter
}
